import React from 'react';
import cn from 'classnames';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const BWContent = ({ additionalClass, children, tag: tagFromProps, space }) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  return (
    <div
      data-bem="BWContent"
      data-tag={tag}
      className={cn({
        'bw-content-wrapper': true,
        space,
        [additionalClass]: additionalClass,
      })}
    >
      <div data-bem="BWContent__children" data-tag={tag}>
        {children}
      </div>
    </div>
  );
};

export default BWContent;
